export const headerStylesInDetailPages =
  "elm-h3 text-left mb-10 w-full lg:max-w-[1200px] lg:mx-auto";
